import { config as mainnetConfig } from "./mainnet";
import { config as testnetConfig } from "./testnet";

export const NETWORK_CONFIG: NetworkConfig =
  process.env.REACT_APP_NETWORK_CONFIG === "mainnet"
    ? mainnetConfig
    : testnetConfig;
